<div class="page-card-container">
    <a [href]="link()">
        <img [src]="img()" alt="">
        <div class="page-card-text-container">
            <h4>{{title()}}</h4>
            <p>{{description()}}</p>
        </div>
    </a>
</div>
